import { render, staticRenderFns } from "./BlockWidget.vue?vue&type=template&id=e368a75c&"
import script from "./BlockWidget.vue?vue&type=script&lang=js&"
export * from "./BlockWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports